import React from 'react';

// Horizontal section tabs (icon + label).
export default function HelpNav({ sections, activeId, onSelect }) {
  return (
    <div className="help-nav" role="tablist" aria-label="Help sections">
      {sections.map((s) => (
        <button
          key={s.id}
          type="button"
          role="tab"
          aria-selected={s.id === activeId}
          className={`help-nav__tab${s.id === activeId ? ' is-active' : ''}`}
          onClick={() => onSelect(s.id)}
        >
          <i className={`fas ${s.icon}`} aria-hidden="true"></i> <span>{s.title}</span>
        </button>
      ))}
    </div>
  );
}
